import React from 'react';
import { formatFilesize } from './helpers/cellFormatters';

const formatFilename = (item) => {
    if (!item?.filename) {
        return '';
    }
    const hideExtension = ['pdf', 'png', 'jpg'].includes(item.extension);
    return item.filename + (hideExtension ? '' : '.' + item.extension);
};

const FilePath = ({ params }) => {
    const item = params?.row ?? params?.value;

    if (!item) {
        return <></>;
    }

    return (
        <>
            {item.thumbnail?.previewUrl && (
                <div className="file-thumbnail-image-container">
                    <img src={item.thumbnail.previewUrl} alt="" />
                </div>
            )}
            <div>
                {formatFilename(item)}
                {item.fileSize != null && (
                    <small> {formatFilesize(item.fileSize)}</small>
                )}
                {item.downloadUrl && (
                    <div className="btn-group btn-group-xs pull-right">
                        <a
                            className="btn btn-link"
                            download={item.filename}
                            href={item.downloadUrl}
                            title="Herunterladen"
                        >
                            <span className="fa fa-circle-down" />
                        </a>
                    </div>
                )}
            </div>
        </>
    );
};

export default FilePath;
